import React, { useEffect, useState } from "react";
import TeamMembersCard from "./TeamMembersCard";
import SectionTitle from "../section-title/SectionTitle";
import axios from "axios";

const TeamMembers = () => {
  const [teamMembers, setTeamMembers] = useState([]);
     const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchTeamData = async () => {
      try {
        const response = await axios.get(
          "https://portal.ebs365.info/api/sites/3/list/team"
        );
        if (response.data && response.data.data) {
          setTeamMembers(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching team data:", error);
      }
    };

    fetchTeamData();
  }, []);


    useEffect(() => {
      const fetchSiteSettings = async () => {
        try {
          const response = await fetch(
            "https://portal.ebs365.info/api/sites/3/pages/home"
          );
          const data = await response.json();
          setHome(data);
        } catch (error) {
          console.error("Error fetching site settings:", error);
        }
      };
  
      fetchSiteSettings();
    }, []);
  
  
    let heroSections = null;
    if (home && home.data && home.data.sections) {
      heroSections = home.data.sections.find(
        (section) => section.title === "home_team"
      );
    }

// console.log("heroSections", heroSections);
  return (
    <div className="team-sec pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <SectionTitle
              title="<span>Our Expert </span>Employees"
              // content="<p>Lorem ipsum dolor sit amet, pellentesque enim lorem quis vivamus amet.</p>"
              content={heroSections && heroSections.items && heroSections.items[0] && heroSections.items[0].contents && heroSections.items[0].contents.title ? heroSections.items[0].contents.title : null}

            />
          </div>
        </div>
        <div className="row" style={{ gap: "20px" }}>
          {teamMembers.map((item) => (
            <TeamMembersCard key={item.id} data={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamMembers;